import {
	AudioConfig,
	PropertyId,
	ResultReason,
	SpeechConfig,
	SpeechRecognizer,
} from 'microsoft-cognitiveservices-speech-sdk';
import { useState } from 'react';

import { useAppDispatch } from 'store/store';
import { setIsRecording } from 'store/ticket-service/ticketSlice';

import { getEnvVar } from 'core/helpers/env-helper';

const useSpeechToText = () => {
	const dispatch = useAppDispatch();

	const [result, setResult] = useState<string>('');

	const speechConfig = SpeechConfig.fromSubscription(
		getEnvVar('REACT_APP_AZURE_SPEECH_SERVICE_KEY') || '',
		getEnvVar('REACT_APP_AZURE_SPEECH_SERVICE_REGION') || ''
	);

	speechConfig.speechRecognitionLanguage = 'en-US';
	speechConfig.setProperty(PropertyId.Speech_SegmentationSilenceTimeoutMs, '3000');

	const audioConfig = AudioConfig.fromDefaultMicrophoneInput();
	const recognizer = new SpeechRecognizer(speechConfig, audioConfig);

	recognizer.recognized = (_s, e) => {
		if (e.result.reason == ResultReason.RecognizedSpeech) {
			dispatch(setIsRecording(false));
			setResult(e.result.text);
		}
	};

	recognizer.canceled = () => {
		recognizer.stopContinuousRecognitionAsync();
	};

	recognizer.sessionStopped = () => {
		recognizer.stopContinuousRecognitionAsync();
	};

	const startRecognition = (): void => {
		dispatch(setIsRecording(true));

		recognizer.startContinuousRecognitionAsync();
	};

	const stopRecognition = (): void => {
		recognizer?.stopContinuousRecognitionAsync(() => {
			dispatch(setIsRecording(true));
			recognizer.close();
		});
	};

	return {
		startRecognition,
		stopRecognition,
		result,
	};
};

export default useSpeechToText;
